import { FinancialLineItemCashFlowType } from '@modeso/types__aumico-lib-settings-be';

/**
 * Form-only representation for a Cash Flow Statement row.
 *
 * Holds exactly one editable value per column (current/previous).
 * These are temporary UI values that are initialized from either:
 * - manuallyEntered* (if present)
 * - otherwise calculated* (system/shadow)
 */
export interface ICashFlowStatementFormEntry {
    name: string;
    fliId: string | null;
    isCustom?: boolean;
    type?: FinancialLineItemCashFlowType;

    /** UI editable values */
    currentValue: number | null;
    previousValue: number | null;

    /** Shadow/system values (read-only in UI, used for tooltip/reset) */
    systemCurrentValue: number | null;
    systemPreviousValue: number | null;

    /** persisted manual overrides */
    manuallyEnteredCurrentValue?: number | null;
    manuallyEnteredPreviousValue?: number | null;
}
